import { ListingStatus } from '@apeiron/common'
import EmporiumSecNavBar from '@src/components/navigationBar/secondary/EmporiumSecNavBar'
import StarThirdNavBar from '@src/components/navigationBar/third/StarThirdNavBar'
import StarListWithFilter from '@src/components/stars/list/StarListWithFilter'
import { GAAssetType } from '@src/constants/googleAnalytics'
import { useSecondaryNavBarContext } from '@src/contexts/share/SecondaryNavBarContext'
import withListTracking from '@src/hoc/withListTracking'
import useQueryInject from '@src/hooks/common/router/useQueryInject'
import { NextPage } from 'next'
import { useEffect } from 'react'

const DEFAULT_QUERY = { nftListingStatus: ListingStatus.LISTING }

const WithTrackingStarList = withListTracking(GAAssetType.Star)(
  StarListWithFilter
)

const StarItemsPage: NextPage<Props> = () => {
  const { setupBar } = useSecondaryNavBarContext()

  const { injected: allowFetch } = useQueryInject(DEFAULT_QUERY)

  useEffect(() => {
    setupBar(<EmporiumSecNavBar index={2} />)

    return () => setupBar(null)
  }, [setupBar])

  return (
    <WithTrackingStarList
      allowFetch={allowFetch}
      thirdNavBar={<StarThirdNavBar index={0} />}
    />
  )
}

type Props = {}

export default StarItemsPage
